export enum ServiceTypes {
  SERVICE = 'SERVICE',
  DISCOUNT = 'DISCOUNT',
}
